import {Component, Input} from "@angular/core";
import {MicroFormService} from "./micro-form.service";
import {MicroFormModel, microFormProvider} from "./micro-form.model";
import * as moment from "moment";
import {createEvent} from "../misc/event.polyfill";

const DATE_FORMAT = "YYYY-MM-DD";

@Component({
  selector: "micro-date",
  templateUrl: "./micro-date.template.pug",
  providers: [microFormProvider(MicroDateComponent)],
  outputs: MicroFormModel.OUTPUTS,
  inputs: [...MicroFormModel.INPUTS, "type"],
})
export class MicroDateComponent extends MicroFormModel {
  private _type: string;

  @Input()
  set type(type: string) {
    this._type = type;
  }

  get type(): string {
    return this._type || "text";
  }

  @Input()
  showAsHyperlink: boolean = false;

  @Input()
  linkTarget: string = "";

  @Input()
  deaultEditView: boolean = false;

  constructor(public microFormService: MicroFormService) {
    super(microFormService);
  }

  edit() {
    this.editing = !this.editing;

    if (this.editing && (!this.editorValue || !this.editorValue.trim())) {
      // Default to today
      this.editorValue = moment(new Date()).utc().format(DATE_FORMAT);
    } else {
      // Date coercion
      const test = moment.utc(this.editorValue);

      if (test.isValid()) {
        this.editorValue = test.format(DATE_FORMAT);
      } else {
        this.editorValue = moment(new Date()).utc().format(DATE_FORMAT);
      }
    }
  }

  save() {
    if (!this.editorValue || !this.editorValue.trim()) {
      super.save();
    } else {
      const test = moment.utc(this.editorValue, DATE_FORMAT, true);

      if (!test.isValid()) {
        const event = createEvent("error");
        event["error"] = new Error(`Incorrect format or invalid date: Date required to by in ${DATE_FORMAT}`);

        this.errorEmitter.emit(event);
      } else {
        super.save();
      }
    }
  }
}
